import React, { useState } from 'react'
import messages from './messages'
import { FormattedMessage } from 'react-intl'
import { Full as Loading } from 'components/Loading'
import { Button, Card } from '@arnsbogroup/react-voicearchive'

const PublicSupplierConsentPage = ({ match }) => {
  const [loading, setLoading] = useState(false)
  const [hasGivenConsent, setHasGivenConsent] = useState(false)
  const [consentUntil, setConsentUntil] = useState(null)
  const hashId = match.params.hashId

  const onConsentClick = () => {
    setLoading(true)
    fetch(`/rest/v2/supplier/${hashId}/consent`, {method: 'POST'})
        .then((response) => response.json())
        .then(({ data, success, errors }) => {
            if (!success) {
                toastr.error(errors.join(', '))
                return
            }
            setConsentUntil(data.consent_until)
            setHasGivenConsent(true)
            setLoading(false)
        })
        .catch((error) => toastr.error(error))
  }

  if (loading || !hashId) {
    return <Loading />
  }

  return (
    <Card className="flex justify-center items-center min-h-screen bg-gray-100 p-6">
      <div className="bg-white p-8 text-center w-full max-w-md shadow-lg rounded-lg">
        <h1 className="text-2xl font-bold text-gray-800 mb-6">
          {!hasGivenConsent ? (
            <FormattedMessage
              {...messages.title}
            />
          ) : (
            <FormattedMessage
              {...messages.titleConsentGiven}
              values={{
                date: consentUntil,
              }}
            />
          )}
        </h1>
        {!hasGivenConsent &&
          <>
            <Button
              onClick={() => onConsentClick()}
            >
              <FormattedMessage {...messages.giveConsent} />
            </Button>
            <div className="mt-4">
              <i>
                <FormattedMessage {...messages.instructions} />
              </i>
            </div>
          </>
        }
      </div>
    </Card>
  )
}

export default PublicSupplierConsentPage
